import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type SocietyParamsInput } from "shared/api/types/society/[societyId]";
import { type SocietyAuthBodyInput } from "shared/api/types/society/[societyId]/auth/index";
import { type SessionView } from "shared/mappers/database/session/session";
export const postSocietyAuthContract: BaseApiContract<
  SocietyParamsInput,
  SocietyAuthBodyInput,
  SessionView
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/auth",
  paramsType: {} as SocietyParamsInput,
  bodyType: {} as SocietyAuthBodyInput,
  responseType: {} as SessionView,
};
export const getSocietyAuthContract: BaseApiContract<
  SocietyParamsInput,
  undefined,
  SessionView
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/auth",
  paramsType: {} as SocietyParamsInput,
  responseType: {} as SessionView,
};
